import { Messages } from '../../codegen/Localize';
import { IControlledPermissionItemInfo } from '../../ts/models/resourceInfoParts';
import { Set } from '../../ts/models/Set';

export enum LockUnlockPermissionsState {
  Locked,
  Unlocked,
  Mixed
}

export enum NestedProjectsPermissionsState {
  Included,
  Excluded,
  Mixed
}

export module LockStatusHelper {

  // Returns true if all numbers in the provided array are the same
  function allSame(arr: number[]): boolean {
    return arr.every((item: number) => arr[0] === item);
  }

  export function getCombinedStatusOfAllItems(
    lockStates: LockUnlockPermissionsState[]
  ): LockUnlockPermissionsState {
    return allSame(lockStates) ? lockStates[0] : LockUnlockPermissionsState.Mixed;
  }

  export function getCombinedStatusOfNestedProjectsState(
    nestedProjectsState: NestedProjectsPermissionsState[]
  ): NestedProjectsPermissionsState {
    return allSame(nestedProjectsState) ? nestedProjectsState[0] : NestedProjectsPermissionsState.Mixed;
  }

  export function getLockStatusOfAllContainers(
    containers: Set<IControlledPermissionItemInfo>
  ): LockUnlockPermissionsState[] {
    return containers.map((container: IControlledPermissionItemInfo) => {
      return container.controlledPermissionsEnabled
        ? LockUnlockPermissionsState.Locked
        : LockUnlockPermissionsState.Unlocked;
    });
  }

  export function getNestedProjectsStatusOfAllContainers(
    containers: Set<IControlledPermissionItemInfo>
  ): NestedProjectsPermissionsState[] {
    return containers.map((container: IControlledPermissionItemInfo) => {
      return container.nestedProjectsPermissionsIncluded
        ? NestedProjectsPermissionsState.Included
        : NestedProjectsPermissionsState.Excluded;
    });
  }

  export function getLockState(
    containers: Set<IControlledPermissionItemInfo>
  ): LockUnlockPermissionsState {
    return getCombinedStatusOfAllItems(getLockStatusOfAllContainers(containers));
  }

  export function getNestedProjectsState(
    containers: Set<IControlledPermissionItemInfo>
  ): NestedProjectsPermissionsState {
    return getCombinedStatusOfNestedProjectsState(getNestedProjectsStatusOfAllContainers(containers));
  }

  // Messages that are used before locking nested projects was supported.
  // To be deleted when removing LockingSubProjectsEnabled FF.
  export function getLegacyLockMessage(lockState: LockUnlockPermissionsState): string {
    switch (lockState) {
      case LockUnlockPermissionsState.Locked:
        return Messages.lockPermissionsSource_currentlyLocked();
      case LockUnlockPermissionsState.Unlocked:
        return Messages.lockPermissionsSource_currentlyUnlocked();
      case LockUnlockPermissionsState.Mixed:
      default:
        return Messages.lockPermissionsSource_currentlyMixed();
    }
  }
}
